import { useVerificationsQuery } from "Api/Queries/Verifications/useVerificationsQuery";
import { DocumentsStepContent } from "Components/Onboarding/shared/DocumentsUpload/DocumentsStepContent";
import { useCurrentUserActingPersonParty } from "Hooks/useCurrentUserActingPersonParty";
import { useCurrentUserParty } from "Hooks/useCurrentUserParty";
import { useIsCurrentUserMerchant } from "Hooks/useIsCurrentUserMerchant";
import { IdentityVerificationStatus, PartyType } from "Infrastructure/Api/Api";

type Props = {
  onNextStepRequested: () => void;
};

export const PersonalDocumentsStep = ({ onNextStepRequested }: Props) => {
  const { data, isLoading } = useVerificationsQuery();
  const { data: userPartyData, isLoading: isLoadingUserParty } =
    useCurrentUserParty();
  const {
    partyRelation: actingPartyRelation,
    isLoading: isActingPersonPartyLoading,
  } = useCurrentUserActingPersonParty();
  const isMerchant = useIsCurrentUserMerchant();

  const isLegalEntity = userPartyData?.type === PartyType.LegalEntity;

  // LegalEntity documents belong to the acting person (StatutoryBody / ProxyHolder / …), never
  // to the LE itself — UploadDocumentsCommand rejects uploads targeting a LegalEntity party.
  // Falling back to userPartyData.publicID would cause a silent BE failure, so for LE require
  // the acting party explicitly.
  const owningPartyPublicID = isLegalEntity
    ? actingPartyRelation?.relatedPartyPublicID
    : userPartyData?.publicID;

  return (
    <DocumentsStepContent
      party={
        data && owningPartyPublicID
          ? {
              publicID: owningPartyPublicID,
              hasDocumentsUploaded:
                data.identityVerificationStatus !==
                IdentityVerificationStatus.NotVerified,
            }
          : undefined
      }
      isLoading={isLoading || isActingPersonPartyLoading || isLoadingUserParty}
      isSecondDocumentRequired={isMerchant}
      onNextStepRequested={onNextStepRequested}
    />
  );
};
